export enum PackagingLabelSize {	
	Small = 0,
	Standard = 10
}